import axios from "axios";
export default {
  successfulCases(data) {
    return axios({
      url: "/api/successful-cases",
      method: "get",
      params: {
        per_page: data.per_page,
        page: data.page,
        category_id: data.category_id
      }
    });
  },
  successfulCaseDetails(id) {
    return axios({
      url: "/api/successful-cases/" + id,
      method: "get",
      params: {}
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/successfulCases.js